import { DOCUMENT } from '@angular/common'
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, inject } from '@angular/core'
import { NgElement, WithProperties } from '@angular/elements'
import { registerCustomElementFactory } from '../../custom-elements/register-custom-element-factory'

/**
 * @public
 *
 * @deprecated
 *    This was added to line up with the requirements of using web components, but should be avoided the same as {@link DomModifierComponent}
 */
export type DomModifierElement = NgElement & WithProperties<DomModifierComponent>

/**
 * @public
 *
 * @deprecated
 *    DOM Modifier was a required component so we could update
 *    the contents of a DOM element, prior to us having any implementation
 *    of the Angular CDK or Reactive Forms. As we progress through
 *    the development of our Reactive Forms solution this may be considered
 *    no longer relevant
 */
@Component({
  selector: 'gpei-dom-modifier',
  templateUrl: './dom-modifier.component.html',
  styleUrls: [ './dom-modifier.component.sass' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class DomModifierComponent implements OnInit {

  private readonly _dom = inject(DOCUMENT)

  private _targetElement: HTMLElement
  private _attributes: Record<string, string> = {}

  @Input()
  @HostBinding()
  element: string

  @Input()
  @HostBinding()
  selector: string

  ngOnInit() {
    this._targetElement = this._dom.querySelector(this.element + this.selector)
    for (let key of Object.keys(this.attributes)) {
      this._targetElement.setAttribute(key, this.attributes[key])
    }
  }

  @Input()
  set attributes(value: Record<string, string> | string) {
    let pendingValue = typeof value == 'string' ? JSON.parse(value) as Record<string, string> : value
    this._attributes = pendingValue
  }

  get attributes(): Record<string, string> {
    return this._attributes
  }

}

/**
 * @public
 *
 * @deprecated
 *    This was added to line up with the requirements of using web components, but should be avoided the same as {@link DomModifierComponent}
 */
export const registerDomModifierElement = registerCustomElementFactory(DomModifierComponent)
